import {
  applyMiddleware,
  compose,
  createStore
} from 'redux'
import { thunk } from 'redux-thunk'

import rootReducer from './reducers'

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    // @ts-ignore
    // tslint:disable-next-line: max-line-length
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
)

export default store
